// /opt/isp_erp/frontend/src/pages/warehouse/Materiales.jsx
import React, { useState, useEffect } from 'react';
import { Box, Typography, Tabs, Tab, Alert, CircularProgress } from '@mui/material';
import axios from '../../api/axios';
import { warehouseAPI } from '../../api/warehouse.api';
import { cargarContextoBodega } from '../../utils/contextoBodega';
import StockTecnicoPanel from '../../components/warehouse/materiales/StockTecnicoPanel';
import AlertasStockPanel from '../../components/warehouse/materiales/AlertasStockPanel';
import MovimientosMaterialesPanel from '../../components/warehouse/materiales/MovimientosMaterialesPanel';
import StockTotalPanel from '../../components/warehouse/materiales/StockTotalPanel';
import CabeceraBodega from '../../components/warehouse/CabeceraBodega';

const PESTANAS = [
  { k: 'stock', t: '📊 Stock por Técnico' },
  { k: 'alertas', t: '⚠️ Alertas de Stock Bajo', soloCentral: true },
  { k: 'movimientos', t: '📋 Movimientos' },
  { k: 'total', t: '📦 Stock Total' },
];

const Materiales = () => {
  const [ctx, setCtx] = useState(undefined);
  const [tab, setTab] = useState('stock');
  const [tecnicos, setTecnicos] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [tecnicoMovimientos, setTecnicoMovimientos] = useState('');

  useEffect(() => {
    let vivo = true;
    cargarContextoBodega().then((c) => { if (vivo) setCtx(c || { central: true, sucursales: [] }); });
    return () => { vivo = false; };
  }, []);

  useEffect(() => {
    if (!ctx) return;
    if (ctx.central === false && ctx.sucursal_id) {
      // El encargado solo trabaja con los técnicos de su sucursal
      axios.get(`/warehouse/sucursales/${ctx.sucursal_id}/personal`)
        .then((r) => setTecnicos((r.data || []).filter((p) => p.rol === 'TECNICO').map((p) => ({ id: p.user_id, username: p.username }))))
        .catch(() => setTecnicos([]));
    } else {
      axios.get('/users')
        .then((r) => setTecnicos((r.data || []).filter((u) => u.roles?.some((x) => x.name === 'tecnico_campo'))))
        .catch(() => setTecnicos([]));
    }
    warehouseAPI.opcionesProveedores()
      .then((r) => setProveedores(r.data || []))
      .catch(() => setProveedores([]));
  }, [ctx]);

  if (ctx === undefined) {
    return (<Box sx={{ p: 6, textAlign: 'center' }}><CircularProgress /></Box>);
  }

  const esEncargado = ctx.central === false;
  const pestanas = PESTANAS.filter((p) => !(p.soloCentral && esEncargado));
  const tabActiva = pestanas.some((p) => p.k === tab) ? tab : 'stock';

  const verMovimientosDe = (tecnicoId) => {
    setTecnicoMovimientos(tecnicoId);
    setTab('movimientos');
  };

  return (
    <Box sx={{ p: 3 }}>
      <CabeceraBodega titulo="Gestión de Materiales" subtitulo="Stock por técnico, movimientos y existencias de la bodega y las sucursales." />
      {esEncargado && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Estás viendo solo el material de tu sucursal y el que tienen tus técnicos. El material nuevo llega con los envíos de la bodega central (Bodega → Sucursales).
        </Alert>
      )}

      <Tabs
        value={tabActiva}
        onChange={(e, v) => { setTab(v); setTecnicoMovimientos(''); }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        {pestanas.map((p) => (<Tab key={p.k} value={p.k} label={p.t} />))}
      </Tabs>

      {tabActiva === 'stock' && (
        <StockTecnicoPanel tecnicos={tecnicos} proveedores={proveedores} onVerMovimientos={verMovimientosDe} ocultarPdf={esEncargado} />
      )}
      {tabActiva === 'alertas' && <AlertasStockPanel tecnicos={tecnicos} proveedores={proveedores} />}
      {tabActiva === 'movimientos' && (
        <MovimientosMaterialesPanel tecnicos={tecnicos} proveedores={proveedores} tecnicoInicial={tecnicoMovimientos} ctx={ctx} />
      )}
      {tabActiva === 'total' && <StockTotalPanel proveedores={proveedores} ctx={ctx} />}
    </Box>
  );
};

export default Materiales;
